import { useAppSelector } from 'js/store/hooks';

export function useUiState() {
  return useAppSelector(state => state.ui);
}
